
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserBaseInfoInterface } from '@/services/Users/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import FeedbackRepository from '../../../../services/QA/feedback';
import { FeedbackForm } from '@/services/QA/feedback/forms/FeedbackForm';
import { FeedbackStatus } from '@/services/QA/feedback/interfaces';

@Component({
  inject: [
    'feedbackRepository',
  ],
})
export default class FeedbackDialog extends Vue {
  @Prop() public chatId: string;
  @Prop() public ticketId: number;
  @Prop() public users: UserBaseInfoInterface[];
  public filteredUsers: UserBaseInfoInterface[];

  private feedbackRepository!: FeedbackRepository;

  private form: WPXFormValue<FeedbackForm> = new WPXFormValue(FeedbackForm);

  private visible: boolean = true;
  private loading: boolean = true;

  public async created(): Promise<void> {
    this.filteredUsers = this.users.filter((user) => !!user.id);
    this.loading = false;
  }

  private async feedback(): Promise<void> {
    try {
      if (this.chatId) {
        await this.feedbackRepository.createChatFeedback(this.chatId, {
          timestamp: Math.floor(Date.now() / 1000),
          feedbackToUsersIds: this.form.data.usersIds,
          feedbackFromUserId: this.$store.getters.id,
          status: FeedbackStatus.SENT,
        });
      }
      if (this.ticketId) {
        await this.feedbackRepository.createTicketFeedback(this.ticketId, {
          timestamp: Math.floor(Date.now() / 1000),
          feedbackToUsersIds: this.form.data.usersIds,
          feedbackFromUserId: this.$store.getters.id,
          status: FeedbackStatus.SENT,
        });
      }
      this.$successDialog.show('Feedback Created Successfully');
      this.destroyComponent();
      this.$emit('review');
    } catch (e) {
      console.log(e);
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
